import React, { useState, useContext } from "react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import logo from "../../../Assets/Images/Logo.png";
import logoDark from "../../../Assets/icons/Sidebaricon/Logo Dark.svg";
import success from "../../../Assets/icons/Successmark.svg";
import { ThemeContext } from "../../../Contexts/ThemeProvider";
import "./style.css";

const PasswordChanged = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { isDarkMode } = useContext(ThemeContext);

  return (
    <div className="password-changed">
      <div className="logo">
        <img src={isDarkMode ? logoDark : logo} alt="Company Logo" />
      </div>

      <div className="changed">
        <div className="changed-card">
          <div className="title">
            <div className="succes-icon">
              <img src={success} alt="Success Icon" />
            </div>

            <div className="main">Password Changed!</div>
            <div className="sub">
              Your password has been changed successfully.
            </div>
          </div>

          <Button
            type="default"
            className="changed-form-button"
            loading={loading}
            onClick={() => {
              setLoading(true);
              navigate("/login");
            }}
          >
            Back to Login
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PasswordChanged;
